module.exports = __webpack_public_path__ + "static/media/caixa.1f38c7e7.png";